import { PageHeaderProvider } from "@/providers/PageHeaderProvider";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_dashboard/campaigns/$id/(edit)/planning/lead-amount-and-period",
)({
  component: RouteComponent,
  staticData: {
    meta: {
      title: "Antal leads & periode",
    },
  },
});

function RouteComponent() {
  return (
    <PageHeaderProvider options={{ title: "Antal leads & periode" }}>
      <Outlet />
    </PageHeaderProvider>
  );
}
